import {Inject, Injectable, Optional} from '@angular/core';
import {ApiBaseUrl} from './api.client';
import {formatIso} from '../utilities/date-util';

@Injectable({providedIn: 'root'})
export class FileDownloadService {

    constructor(
        @Optional() @Inject(ApiBaseUrl) private baseUrl?: string) {
    }

    buildUrl(endpoint: string, data: {[k: string]: any} = {}): string {
        let url = `${this.baseUrl || ''}${endpoint}`;

        const query = this.getQueryParams(data);
        if (query) {
            url += `?${query}`;
        }

        return url;
    }

    private getQueryParams(data: {[k: string]: any}): string {
        if (data.startDate) {
            data.startDate = formatIso(data.startDate);
        }

        if (data.endDate) {
            data.endDate = formatIso(data.endDate);
        }

        return Object.keys(data)
            .filter((key) => {
                if (Array.isArray(data[key])) {
                    return data[key].length > 0;
                }
                return !!data[key];
            })
            .map((key) => `${key}=${data[key]}`)
            .join('&');
    }
}
